export const DummyComponent = ({children}: {children: JSX.Element}): JSX.Element => children;
